'use client';

import { Example } from '@/types/Example';
import { useDebounce } from '@uidotdev/usehooks';
import { useEffect, useState } from 'react';
import CommandCatalogue from './CommandCatalogue';
import { Input } from './ui/input';

interface MainCommandListProps {
  examples: Example[];
}

const MainCommandList = (props: MainCommandListProps) => {
  const { examples } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 150);
  const [filteredExamples, setFilteredExamples] = useState(examples);

  useEffect(() => {
    const filteredExamples = examples.filter((example) =>
      example.example.toLowerCase().includes(debouncedSearchTerm.toLowerCase()),
    );
    setFilteredExamples(filteredExamples);
  }, [debouncedSearchTerm, examples]);

  return (
    <div className="container max-w-2xl p-4 sm:p-8">
      <Input
        className={`searchbox bg-white`}
        type="text"
        placeholder="Find a command (e.g. 'rebase')"
        onChange={(e) => setSearchTerm(e.target.value)}
        autoFocus
      />
      <div className="mt-2 mb-4 flex w-full items-center justify-end text-xs sm:mb-8">
        <span className="text-gray-500">{filteredExamples.length} results</span>
      </div>
      <CommandCatalogue
        cheats={filteredExamples}
        showAsGrid={false}
        showDifficulty
        editable
      />
    </div>
  );
};

export default MainCommandList;
